import * as React from 'react';

// because we need to use this on SSR use React Context instead of Apollo cache
//  to avoid complications with dealing between server and client communication
export const PageContext = React.createContext({
  title: 'Probemas'
});
